<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4"></div>

      <div class="col-lg-4">
        <div class="card">
          <p class="title">Wachtwoord wijzigen</p>

          <div class="change-password-form">
            <div class="form-group">
              <h3>Huidig wachtwoord</h3>
              <input id="current-password-field" type="password" class="form-control" v-model="passwordObj.currentPassword"
                     placeholder="">
            </div>

            <div class="form-group">
              <h3>Nieuw wachtwoord</h3>
              <input id="new-password-field" type="password" class="form-control" v-model="passwordObj.newPassword"
                     placeholder="">
            </div>

            <div class="form-group">
              <h3>Nieuw wachtwoord bevestigen</h3>
              <input id="new-password-confirm-field" type="password" class="form-control"
                     v-model="passwordObj.newPasswordRepeated" placeholder="">
            </div>

            <v-button class="save-changes-button" buttonText="Wachtwoord wijzigen" v-on:clicked="updateUserPassword"
                      :enabled="true"></v-button>
            <a class="cancel-button" href="#" v-on:click.prevent="cancelClicked">Annuleren</a>

          </div>
        </div>
      </div>

      <div class="col-lg-4"></div>

    </div>
  </div>
</template>

<script>
import VButton from "@/components/UI/VButton";
import log from "@/utils/logger";
import { AuthApi } from "sandpiper_api";

export default {
  name: "ChangePassword",
  components: { VButton },
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      passwordObj: {
        currentPassword: '',
        newPassword: '',
        newPasswordRepeated: ''
      }
    }
  },
  methods: {
    cancelClicked()
    {
      this.$router.push({ name: "profile" });
    },
    async updateUserPassword()
    {
      try
      {
        await this.doApiRequest(() => new AuthApi().doPasswordUpdate({
          currentPassword: this.passwordObj.currentPassword,
          newPassword: this.passwordObj.newPassword,
          newPasswordRepeated: this.passwordObj.newPasswordRepeated
        }));

        await this.$router.push("/profile");
      }
      catch (e)
      {
        // TODO - handle error
        log.error("Failed to update password - %o", e);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.agenda-cards
{
  align-items: flex-start;
}

.card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;
  //min-width: 402px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.save-changes-button
{
  margin-bottom: 25px;
}

.cancel-button
{
  align-self: center;
}

.change-password-form
{
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}
</style>